// 모듈 공용 수학(할당 없음). 호·트레일이 쓰는 평면 기저와 이징.
// 평면 기저: e1 = 전방(sin yaw, 0, cos yaw), e2 = 평면 안에서 e1에 직교하는 방향(roll 0이면 옆, PI/2이면 위).
// 호 위의 점 = 중심 + (e1·cos a + e2·sin a)·반경.
const F = new Float64Array(6);

/** 평면 기저를 F[0..5]에 계산한다: e1 = F[0..2], e2 = F[3..5] */
export function planeFrame(yaw: number, roll: number): Float64Array {
  const sy = Math.sin(yaw), cy = Math.cos(yaw), sr = Math.sin(roll), cr = Math.cos(roll);
  F[0] = sy; F[1] = 0; F[2] = cy;
  F[3] = cy * cr; F[4] = sr; F[5] = -sy * cr;
  return F;
}

export const clamp01 = (v: number): number => (v < 0 ? 0 : v > 1 ? 1 : v);
export const easeOut = (u: number): number => 1 - (1 - u) * (1 - u) * (1 - u);
export const easeOutQuad = (u: number): number => 1 - (1 - u) * (1 - u);
